import { ApiPostPhone } from './../Types/UserPhone/Api';
import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import { filterShallowObject } from 'Services/extraObject'
import { ApiSignupUser } from 'Types'

const endpoint = `${apiUrl.stable}/cliente`

/** Signup a new user */
export const signupUser = (data: ApiSignupUser) => {
  const url = `${endpoint}/cadastra`

  return axios.post(url, data)
}

export const getUserInfo = () => {
  const url = `${endpoint}/obter`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

export const editUserInfo = async (data) => {
  try {
    const url = `${endpoint}/atualizar`

    const headers = {
      ...jsonWebToken.header
    }

    const result = await axios.put(url, data, { headers })

    return result
  } catch (err) {
    throw err
  }
}

export const checkValidUserEmail = (email) => {
  const url = `${endpoint}/verifica-email`

  const headers = {
    'Accept': 'application/json',
    'Content-type': 'application/json',
  }

  return axios.post(url, JSON.stringify(email), { headers })
}

/**
 * Add a new address to the user's account
 * @param {number} page
 * @param {object} [options]
 * @param {string} [options.filter]
 * @param {number} [options.pageSize]
 * @param {boolean} [options.alphabeticalOrder]
 * @returns {Promise.<{ data: ApiAddressList }>} data
 */
export const getAddressList = (page = 1, options = {}) => {
  const url = `${endpoint}/endereco/lista`

  const queries = {
    Page: page,
    PageSize: options.pageSize || null,
    Filter: options.filter || null,
    AlphabeticalOrder: typeof options.alphabeticalOrder !== 'undefined'
      ? options.alphabeticalOrder
      : null
  }

  const params = filterShallowObject(queries, item => item !== null)

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers, params })
}

/**
 * Add a new address to the user's account
 * @param {number} addressId
 * @returns {Promise.<{ data: ApiAddressDetails }>} data
 */
export const getAddressDetails = (addressId) => {
  const url = `${endpoint}/endereco/detalhe`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    id: addressId
  }

  return axios.get(url, { headers, params })
}

/**
 * Add a new address to the user's account
 * @param {ApiAddressCreate} data
 */
export const addAddress = (data) => {
  const url = `${endpoint}/endereco/adiciona`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, data, { headers })
}

/**
 * Add a new address to the user's account
 * @param {ApiAddressUpdate} data
 */
export const updateAddress = (data) => {
  const url = `${endpoint}/endereco/altera`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.put(url, data, { headers })
}

/**
 * Add a new address to the user's account
 * @param {number} addressId
 */
export const removeAddress = (addressId) => {
  const url = `${endpoint}/endereco/remove`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    id: addressId
  }

  return axios.delete(url, { headers, params })
}


export const uploadUserAvatar = (photoPath) => {
  const url = `${endpoint}/atualizar-foto-perfil`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    photoPath
  }

  return axios.put(url, data, { headers })

}


export const addPhoneValid = (data: ApiPostPhone ) => {
  const url = `${endpoint}/adicionar-telefone`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })

}
 // obtendo telefone da tabela userPhone
export const pickUserPhone = () => {
  const url = `${endpoint}/obter-telefone`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const removeUserPhone = (phoneId: number) => {
  const url = `${endpoint}/remover-telefone`

  const headers = { ...jsonWebToken.header }
  const params =  {
    phoneId
  }

  return axios.delete(url, { headers, params })

}

export const setDefaultPhone = (phoneId: number) => {
  const url = `${endpoint}/telefone-principal`

  const headers = { ...jsonWebToken.header }

  const params =  {
    phoneId
  }

  return axios.put(url, '' ,{ headers, params })

}

export default {
  signupUser,
  getAddressList,
  getAddressDetails,
  addAddress,
  updateAddress,
  removeAddress,
  addPhoneValid,
}